import "./header.scss";

export default function Header() {
    return (
        <header>
            <h1 className="text-center">Tic Tac Toe</h1>
        </header>
    );
}
